module.exports = __webpack_public_path__ + "static/banner-footer-update-data-pe-MB-72acaea299b96adea03813d0d2ec0026.png";